// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selection-summary {
  margin-top: 2rem;
  padding: 1rem;
  border: 1px solid darkgrey;
  background-color: rgba(0,0,0,.05);
}

.summary-card {
  margin-bottom: 1rem;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/styles/SelectionSummary.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".selection-summary {\n  margin-top: 2rem;\n  padding: 1rem;\n  border: 1px solid darkgrey;\n  background-color: rgba(0,0,0,.05);\n}\n\n.summary-card {\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: white;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
